module.exports = __webpack_public_path__ + "img/BCP.7cd7cd9f.jpg";